import { ROUTE_PATH_ALERTS, ROUTE_PATH_HOME,ROUTE_PATH_SCAM, ROUTE_PATH_IDENTITY, ROUTE_PATH_PROTECTION } from '../../constants';
import { SiteNavbarTranslations } from '../types';

export const translations: SiteNavbarTranslations = {
  menu: {
    home: {
      to: ROUTE_PATH_HOME,
      exact: true,
      children: 'ACCUEIL'
    },
    ScamDetection: {
      to: ROUTE_PATH_SCAM,
      exact: true,
      children: 'DÉTECTION DE FRAUDE'
    },
     monitoringAndAlerts: {
      to: ROUTE_PATH_ALERTS,
      exact: true,
      children: 'SURVEILLANCE ET ALERTES'
    },
    identityRestoration: {
      to: ROUTE_PATH_IDENTITY,
      exact: true,
      children: 'RÉTABLISSEMENT DE L’IDENTITÉ'
    },
    lostWalletProtection: {
      to: ROUTE_PATH_PROTECTION,
      exact: true,
      children: 'PERTE DE PORTEFEUILLE'
    }
  }
};
